"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _isHexColorValue = _interopRequireDefault(require("../is-hex-color-value"));

/**
 *  A single legend item
 *
 * @param {object} options Object containing all options (SEE BELOW)
 * @param {string} options.label The label that will be displayed
 * @param {string} options.color The hex value for the color to be displayed
 *
 * @property {string} label
 * @property {string} color
 */
var LegendItem = function LegendItem(_ref) {
  var label = _ref.label,
      color = _ref.color;
  (0, _classCallCheck2.default)(this, LegendItem);

  if (typeof label !== 'string') {
    throw new TypeError("options.label must be a string. Provided value: ".concat(label));
  }

  if (!(0, _isHexColorValue.default)(color)) {
    throw new TypeError("options.color must be a valid hex color. Provided value: ".concat(color));
  }

  this.label = label;
  this.color = color;
  Object.freeze(this);
};

exports.default = LegendItem;